import { AppUtils } from '../../utils/index';

import { BaseApiModel } from './BaseApiModel';


/**
 * APIL Url: ADAC.Internet.Core.Models.Schadenmeldung.SchadenmeldungLand
 * 
 * Endpoints: /api/schadenmeldungen/schutzbrief, /api/schadenmeldungen/aks, /api/schadenmeldungen/rrv
 */
export class SchadenmeldungLandApi extends BaseApiModel {
	constructor(initialProperties?: Partial<SchadenmeldungLandApi>) {
		super();
		if (initialProperties) {
			AppUtils.Helper.mapObject(initialProperties, this);
		}
	}

	protected land: string;
	/**
	 * Description: Klarname des Landes
	 * APIL Type: string
	 */
	get Land(): string {
		return this.land;
	}

	/**
	 * Description: Klarname des Landes
	 * APIL Type: string
	 */
	set Land(value: string) {
		this.land = value;
	}

	protected landKnz: string;
	/**
	 * Description: Länderkürzel
	 * APIL Type: string
	 */
	get LandKnz(): string {
		return this.landKnz;
	}

	/**
	 * Description: Länderkürzel
	 * APIL Type: string
	 */
	set LandKnz(value: string) {
		this.landKnz = value;
	}

	/**
	 * Creates a new model object and copies the values from the provided data object (or other application model) to the created model.
	 */
	public static createFromObject(dataObject: { [key: string]: any }): SchadenmeldungLandApi {
		return AppUtils.Helper.createFromMap(dataObject, SchadenmeldungLandApi, (key, value) => {
			switch (key.toLowerCase()) {

				default:
					return value;
			}
		});
	}

	public toRequestObject(): { [key: string]: any } {
		const result: { [key: string]: any } = {};
		result.Land = this.land;
		result.LandKnz = this.landKnz;
		return result;
	}

	public toJsonString(): string {
		return JSON.stringify(this.toRequestObject());
	}
}